import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

// Julia 3D + Spherical — classic 3D fractal sphere
export const example30 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'deluksic',
    name: 'Julia 3D + Spherical',
    description: 'classic 3D fractal sphere',
  },
  renderSettings: {
    dimensions: 3,
    exposure: 0.25,
    skipIters: 20,
    drawMode: 'light',
    pointInitMode: 'pointInitUnitBall',
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 0.4,
      phi: 1.4,
      radius: 2.2,
      target: [0, 0, 0],
      fov: 60,
    },
  },
  transforms: {
    [tid('3d_julia_a')]: {
      probability: 0.5,
      preAffine: {
        a: 0.8,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.8,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.8,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.1, y: 0.3 },
      variations: {
        [vid('3d_julia_a_v0')]: { type: 'julia3D', weight: 1 },
      },
    },
    [tid('3d_julia_b')]: {
      probability: 0.3,
      preAffine: {
        a: 0.9,
        b: 0.1,
        c: 0,
        d: 0,
        e: -0.1,
        f: 0.9,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.9,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.2, y: 0.1 },
      variations: {
        [vid('3d_julia_b_v0')]: { type: 'spherical3D', weight: 0.6 },
        [vid('3d_julia_b_v1')]: { type: 'linear3D', weight: 0.4 },
      },
    },
    [tid('3d_julia_c')]: {
      probability: 0.2,
      preAffine: {
        a: 0.5,
        b: 0,
        c: 0,
        d: 0.1,
        e: 0,
        f: 0.5,
        g: 0,
        h: 0.1,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0.1,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.5, y: -0.2 },
      variations: {
        [vid('3d_julia_c_v0')]: { type: 'julia3D', weight: 0.7 },
        [vid('3d_julia_c_v1')]: { type: 'sinusoidal3D', weight: 0.3 },
      },
    },
  },
})
